module.exports = __webpack_public_path__ + "static/media/very-happy.5b2fa98c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/emoji/very-happy.png
// module id = 32
// module chunks = 0